import Notiflix from "notiflix";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  DeleteOutlined,
  LeftOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Form,
  Input,
  InputNumber,
  Layout,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
  Typography,
} from "antd";
import styles from "../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";

const toTitleCase = (str) =>
  str?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) ?? str;

const formatAmount = (value) =>
  value != null
    ? Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "—";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const EditBranchConfiguration = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state: selectedBranchConfigKey } = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const { Text, Title } = Typography;
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  // CHARGES FORM REQURED VARIABLES
  const [chargeTableSource, setChargeTableSource] = useState([]);
  // DECLARED VARIABLES FOR CHARRGES FORM
  const [isLimitModalOpen, setIsLimitModalOpen] = useState(false);
  const [isTransactionModalOpen, setIsTransactionModalOpen] = useState(false);
  const [officeData, setOfficeData] = useState([]);
  const [configureLimitTableSource, setConfigurelimitTableSource] = useState(
    [],
  );
  const [codeListId, setCodeListId] = useState({});
  const [configureTransactionTableSource, setConfigureTransactionTableSource] =
    useState([]);
  const [codeValueData, setCodeValueData] = useState([]);
  const [transactionCurrencyData, setTransactionCurrencyData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [LimitCount, setLimitCount] = useState(0);
  const [transactionCount, setTransactionCount] = useState(0);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    authForm: null,
    branchCcyRestrConfs: [],
    branchOperationTransactionType: [],
  });

  console.log(formData);
  useEffect(() => {
    // getProductTemplate(state);
    getOffices();
    getCurrencies();
    getTellerTransactionType();
  }, [selectedBranchConfigKey]);

  useEffect(() => {
    if (currencyData.length > 0) {
      getBranchConfigById(); // safe to call now
    }
  }, [currencyData]);

  const getTellerTransactionType = () => {
    setIsLoading(true);

    const url = `${apiConfig.Codes}/codevalue/TellerTransactionType`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;

        getCodeValues(objList);

        setIsLoading(false);
      }
    });
  };

  const getCodeValues = (param) => {
    setIsLoading(true);

    const url = `${apiConfig.Codes}/${param.id}/codevalues`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCodeValueData = [];
        console.log(res);

        objDetails?.forEach((element) => {
          tempCodeValueData.push({
            value: element.id,
            label: element.name,
          });
        });

        setCodeValueData(tempCodeValueData);

        setIsLoading(false);
      }
    });
  };

  const getOffices = () => {
    setIsLoading(true);

    const url = apiConfig.Offices;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        // setTemplateConfigDetail(res);
        const objDetails = res;
        let tempOfficeData = [];

        objDetails?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);

        setIsLoading(false);
      }
    });
  };

  const getCurrencies = () => {
    setIsLoading(true);

    const url = apiConfig.Currencies;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetails = res;
        let tempCurrencyData = [];
        console.log(res);

        objDetails?.selectedCurrencyOptions?.forEach((element) => {
          tempCurrencyData.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrencyData);

        setIsLoading(false);
      }
    });
  };

  const getBranchConfigById = () => {
    setIsLoading(true);
    const url = apiConfig.Branchoprconfig + `/${selectedBranchConfigKey.id}`;
    const body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
      } else {
        const objList = res;
        setCodeListId(objList);

        // 1. Populate Ant Form fields
        useForm.setFieldsValue({
          officeId: objList.officeId.id,
          allowTellerTillAuth: objList.allowTellerTillAuth,
          allowVaultTillAuth: objList.allowVaultTillAuth,
        });

        // 2. Prepare limit data for the Branch Limit Table
        const limitData =
          objList?.branchCcyRestrConfData?.map((item) => ({
            key: item.id,
            currencyCode: item.currencyCode,
            authThresholdAmount: item.authThresholdAmount,
            transactionLimit: item.transactionLimit,
          })) || [];

        // 3. Prepare transaction data for the Transaction Table
        const transactionData = objList?.branchCcyRestrConfData?.flatMap(
          (item) =>
            item.branchOperationTransactionTypeData?.map((tx) => ({
              key: tx.id,
              currencyCode: item.currencyCode,
              transactionType: tx.transactionType,
              transactionTypeValue:
                toTitleCase(tx.transactionType?.name) || "N/A",
              transactionTypeLimit: tx.transactionTypeLimit || 0,
              locale: tx.locale || "en",
            })) || [],
        );

        // 4. Prepare transaction currency dropdown data
        const configCurrencyList = res?.branchCcyRestrConfData || [];

        const formattedCurrencyData = configCurrencyList.map((configItem) => {
          const currencyInfo = currencyData.find(
            (cur) => cur.value === configItem.currencyCode,
          );

          return {
            value: configItem.currencyCode,
            label: currencyInfo?.label || configItem.currencyCode,
          };
        });

        // 5. Set state for formData — this is your main objective
        const authForm = {
          officeId: objList.officeId.id,
          allowTellerTillAuth: objList.allowTellerTillAuth,
          allowVaultTillAuth: objList.allowVaultTillAuth,
        };

        const branchCcyRestrConfs = limitData.map((conf) => ({
          locale: "en", // You can adjust this if locale exists in the data
          currencyCode: conf.currencyCode,
          authThresholdAmount: conf.authThresholdAmount,
          transactionLimit: conf.transactionLimit,
        }));

        const branchOperationTransactionType = transactionData.map((tx) => ({
          locale: tx.locale || "en",
          currencyCode: tx.currencyCode,
          transactionType: tx.transactionType,
          transactionTypeLimit: tx.transactionTypeLimit,
        }));

        setFormData({
          authForm,
          branchCcyRestrConfs,
          branchOperationTransactionType,
        });

        // 6. Set UI-related table states
        setTransactionCurrencyData(formattedCurrencyData);
        setConfigurelimitTableSource(limitData);
        setConfigureTransactionTableSource(transactionData);

        setIsLoading(false);
      }
    });
  };

  const limitColumn = [
    {
      title: "Currency",
      dataIndex: "currencyCode",
    },
    {
      title: "Authorization Threshold",
      dataIndex: "authThresholdAmount",
      render: (v) => formatAmount(v),
    },
    {
      title: "Daily Transaction Limit",
      dataIndex: "transactionLimit",
      render: (v) => formatAmount(v),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureLimitTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleBranchLimitDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const transactionColumn = [
    {
      title: "Currency",
      dataIndex: "currencyCode",
    },
    {
      title: "Transaction Type",
      dataIndex: "transactionTypeValue",
    },
    {
      title: "Transaction Type Limit",
      dataIndex: "transactionTypeLimit",
      render: (v) => formatAmount(v),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureTransactionTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleTransactionLimitDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const onSubmit = () => {
    const url = apiConfig.Branchoprconfig + `/${selectedBranchConfigKey.id}`;
    const branchCcyRestrConfs = formData.branchCcyRestrConfs.map((conf) => {
      const matchingOperations = formData.branchOperationTransactionType
        .filter((op) => op.currencyCode === conf.currencyCode)
        .map((op) => ({
          branchOperationTransactionType: {
            locale: op.locale || "en",
            transactionType: op.transactionType?.id ?? op.transactionType,
            transactionTypeLimit:
              op.transactionTypeLimit || conf.transactionLimit,
          },
        }));

      return {
        branchCcyRestrConf: {
          locale: conf.locale || "en",
          currencyCode: conf.currencyCode,
          authThresholdAmount: conf.authThresholdAmount.toString(),
          transactionLimit: conf.transactionLimit.toString(),
          branchOperationTransactionTypes: matchingOperations,
        },
      };
    });

    let formValues = {
      ...formData.authForm,
      branchCcyRestrConfs,
    };

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
      id: selectedBranchConfigKey.id,
    };
    // console.log(formValues);
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateSavingsAccountMsg);
          // navigate("/detail-savings-account", {
          //   state: { ...state, statusValue: accountStatus.submittedAndPending },
          // });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/SYA0400");
          setIsLoading(false);
        },
      },
    );
  };

  function onCancel() {
    navigate("/sya0400");
  }

  const handleBranchLimitDelete = (key) => {
    console.log(key);
    Notiflix.Confirm.show(
      "Please confirm action",
      "",
      "Yes",
      "No",
      function () {
        // Remove from UI table
        const newData = configureLimitTableSource.filter(
          (item) => item.key !== key.key,
        );

        console.log(newData);
        setConfigurelimitTableSource(newData);
        console.log(configureLimitTableSource);

        // ALSO update formData.branchCcyRestrConfs if that’s where submit pulls from
        setFormData((prev) => ({
          ...prev,
          branchCcyRestrConfs: newData, // directly use newData
        }));

        // Update dropdown options
        const tempNewCurrencyData = newData.map((configItem) => {
          const matchedCurrency = currencyData?.find(
            (currencyItem) => currencyItem.value === configItem.currencyCode,
          );

          return {
            value: configItem.currencyCode,
            label: matchedCurrency?.label || configItem.currencyCode,
          };
        });

        setTransactionCurrencyData(tempNewCurrencyData);
      },
      function () {
        // Cancelled
      },
    );
  };

  const handleTransactionLimitDelete = (key) => {
    Notiflix.Confirm.show(
      "Please Confirm Action",
      "",
      "Yes",
      "No",

      function () {
        // Filter the visible table
        const newData = configureTransactionTableSource.filter((item) => {
          const itemTypeId =
            typeof item.transactionType === "object"
              ? item.transactionType.id
              : item.transactionType;

          const keyTypeId =
            typeof key.transactionType === "object"
              ? key.transactionType.id
              : key.transactionType;

          return (
            itemTypeId !== keyTypeId || item.currencyCode !== key.currencyCode
          );
        });

        setConfigureTransactionTableSource(newData);

        // Also update formData
        const updatedForm = {
          ...formData,
          branchOperationTransactionType:
            formData.branchOperationTransactionType.filter((item) => {
              const itemTypeId =
                typeof item.transactionType === "object"
                  ? item.transactionType.id
                  : item.transactionType;

              const keyTypeId =
                typeof key.transactionType === "object"
                  ? key.transactionType.id
                  : key.transactionType;

              return (
                itemTypeId !== keyTypeId ||
                item.currencyCode !== key.currencyCode
              );
            }),
        };

        setFormData(updatedForm);
      },

      function () {
        // Cancel
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editBranchConfiguration}
        pageItems={staticConfig.editBranchConfigurationBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={useForm}
            layout="vertical"
            onValuesChange={(changedValues, allValues) => {
              setFormData((prev) => ({
                ...prev,
                authForm: {
                  ...prev.authForm,
                  ...allValues,
                },
              }));
            }}
            onFinish={onSubmit}
          >
            <Divider style={{ marginTop: 5, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.authorizationInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.branch}
                  name={"officeId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.branch),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.branch,
                      "select",
                    )}
                    options={officeData}
                    allowClear
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.tellerTillAuthorization}
                  name={"allowTellerTillAuth"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Required Field",
                  //   },
                  // ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    showSearch
                    options={staticConfig.statusData}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.vaultAuthorization}
                  name={"allowVaultTillAuth"}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Required Field",
                  //   },
                  // ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase(),
                      )
                    }
                    showSearch
                    options={staticConfig.statusData}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.limitsInfo}
              </Title>
            </Divider>
            <BranchLimitModal
              isLimitModalOpen={isLimitModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsLimitModalOpen={setIsLimitModalOpen}
              setFormData={setFormData}
              //   paymentTypeOptions={paymentTypeOptions}
              //   assetAccountOptions={assetAccountOptions}
              setConfigurelimitTableSource={setConfigurelimitTableSource}
              configureLimitTableSource={configureLimitTableSource}
              LimitCount={LimitCount}
              setLimitCount={setLimitCount}
              currencyData={currencyData}
              transactionCurrencyData={transactionCurrencyData}
              setTransactionCurrencyData={setTransactionCurrencyData}
            />

            {configureLimitTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {configureLimitTableSource.length > 1
                      ? "Added Branch Limits"
                      : "Added Branch Limit"}
                  </Title>
                </Divider>
                <Table
                  columns={limitColumn}
                  dataSource={configureLimitTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}

            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.transactionInfo}
              </Title>
            </Divider>
            <BranchTransactionLimitModal
              isTransactionModalOpen={isTransactionModalOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsTransactionModalOpen={setIsTransactionModalOpen}
              setConfigureTransactionTableSource={
                setConfigureTransactionTableSource
              }
              formData={formData}
              setFormData={setFormData}
              configureTransactionTableSource={configureTransactionTableSource}
              transactionCount={transactionCount}
              setTransactionCount={setTransactionCount}
              currencyData={currencyData}
              // currencyData={currencyData}
              codeValueData={codeValueData}
              transactionCurrencyData={transactionCurrencyData}
              setTransactionCurrencyData={setTransactionCurrencyData}
            />

            {configureTransactionTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {configureTransactionTableSource.length > 1
                      ? "Added Branch Transactions"
                      : "Added Branch Transaction"}
                  </Title>
                </Divider>
                <Table
                  columns={transactionColumn}
                  dataSource={configureTransactionTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};
export default EditBranchConfiguration;

const BranchLimitModal = (props) => {
  const {
    isLoading,
    setIsLoading,
    setConfigurelimitTableSource,
    configureLimitTableSource,
    isLimitModalOpen,
    setIsLimitModalOpen,
    LimitCount,
    setLimitCount,
    setFormData,
    currencyData,
    setTransactionCurrencyData,
    transactionCurrencyData,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsLimitModalOpen(true);
  };
  const handleOk = () => {
    setIsLimitModalOpen(false);
  };
  const handleCancel = () => {
    setIsLimitModalOpen(false);
  };

  const handleBranchLimitSave = (formValues) => {
    const newAuthLimit = {
      key: LimitCount,
      id: LimitCount,
      locale: "en",
      authThresholdAmount: formValues.authThresholdAmount,
      currencyCode: formValues.currencyCode,
      transactionLimit: formValues.transactionLimit,
    };

    // Check duplicate in configureLimitTableSource
    const foundLimits = configureLimitTableSource.some(
      (item) => item.currencyCode === newAuthLimit.currencyCode,
    );

    if (foundLimits) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Limit allowed!");
      return;
    }

    // Update the UI table source
    const updatedLimitsSource = [...configureLimitTableSource, newAuthLimit];
    setConfigurelimitTableSource(updatedLimitsSource);
    setLimitCount(LimitCount + 1);

    // ✅ Update formData.branchCcyRestrConfs
    setFormData((prev) => {
      const existing = prev.branchCcyRestrConfs || [];

      // Check if item with the same currencyCode exists
      const updatedConfs = [...existing];
      const index = updatedConfs.findIndex(
        (conf) => conf.currencyCode === newAuthLimit.currencyCode,
      );

      const updatedItem = {
        locale: newAuthLimit.locale,
        currencyCode: newAuthLimit.currencyCode,
        authThresholdAmount: newAuthLimit.authThresholdAmount,
        transactionLimit: newAuthLimit.transactionLimit,
      };

      if (index !== -1) {
        // Replace existing
        updatedConfs[index] = updatedItem;
      } else {
        // Add new
        updatedConfs.push(updatedItem);
      }

      return {
        ...prev,
        branchCcyRestrConfs: updatedConfs,
      };
    });

    // Update the transactionCurrencyData if needed
    const tempNewCurrencyData = updatedLimitsSource.map((configItem) => {
      const matchedCurrency = currencyData?.find(
        (currencyItem) => currencyItem.value === configItem.currencyCode,
      );

      return {
        value: configItem.currencyCode,
        label: matchedCurrency?.label || configItem.currencyCode,
      };
    });

    setTransactionCurrencyData(tempNewCurrencyData);
    useForm.resetFields();
    setIsLimitModalOpen(false);
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp; {"Add"}
      </Button>

      <Modal
        title="Limit Information Setup"
        open={isLimitModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleBranchLimitSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"currencyCode"}
                label={labelConfig.currency}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.currency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currency,
                    "select",
                  )}
                  options={currencyData}
                  allowClear
                  showSearch
                  // onChange={onChangeCurrency}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="authThresholdAmount"
                label={labelConfig.authThreshold}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.authThreshold),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.authThreshold,
                  )}
                  style={styles.ofInputFieldNumber}
                  formatter={(v) =>
                    `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(v) => v?.replace(/,/g, "")}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionLimit"
                label={labelConfig.transactionLimit}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transactionLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.transactionLimit,
                  )}
                  style={styles.ofInputFieldNumber}
                  formatter={(v) =>
                    `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(v) => v?.replace(/,/g, "")}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const BranchTransactionLimitModal = (props) => {
  const {
    isLoading,
    setIsLoading,
    setConfigureTransactionTableSource,
    configureTransactionTableSource,
    isTransactionModalOpen,
    setIsTransactionModalOpen,
    transactionCount,
    setTransactionCount,
    transactionCurrencyData,
    currencyData,
    codeValueData,
    setTransactionCurrencyData,
    formData,
    setFormData,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsTransactionModalOpen(true);
  };
  const handleOk = () => {
    setIsTransactionModalOpen(false);
  };
  const handleCancel = () => {
    setIsTransactionModalOpen(false);
  };

  console.log(codeValueData);

  const handleBranchTransactionSave = (formValues) => {
    console.log(formValues.transactionType);
    const newTransactionLimit = {
      key: transactionCount,
      id: transactionCount,
      transactionType: formValues.transactionType,
      transactionTypeValue:
        toTitleCase(
          codeValueData.find(
            (item) => item.value === formValues.transactionType,
          )?.label,
        ) || "-",
      currencyCode: formValues.currencyCode,
      transactionTypeLimit: formValues.transactionTypeLimit,
    };

    setTransactionCount(transactionCount + 1);

    const duplicateFound = configureTransactionTableSource.some(
      (item) =>
        item.currencyCode === newTransactionLimit.currencyCode &&
        item.transactionTypeValue === newTransactionLimit.transactionTypeValue,
    );

    if (duplicateFound) {
      BOM.AlertMsg(
        cnt.WARNING,
        "Duplicate transaction type and currency combination not allowed!",
      );
      return;
    }

    // ✅ Update local table
    setConfigureTransactionTableSource([
      ...configureTransactionTableSource,
      newTransactionLimit,
    ]);

    // ✅ Update formData for parent
    setFormData({
      ...formData,
      branchOperationTransactionType: [
        ...(formData.branchOperationTransactionType || []),
        newTransactionLimit,
      ],
    });

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp; {"Add"}
      </Button>

      <Modal
        title="Transaction Limit Setup"
        open={isTransactionModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleBranchTransactionSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"currencyCode"}
                label={labelConfig.currency}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.currency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currency,
                    "select",
                  )}
                  options={transactionCurrencyData}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionType"
                label={labelConfig.transcationType}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.transcationType),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.transcationType,
                    "select",
                  )}
                  options={codeValueData}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionTypeLimit"
                label={labelConfig.limit}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.limit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.limit)}
                  style={styles.ofInputFieldNumber}
                  formatter={(v) =>
                    `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(v) => v?.replace(/,/g, "")}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
